import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/ai-multi-sensor-4.png";
import type { Product } from "../../types";
import { physicalSecurityDomeTurret } from "../product-list-groups/physicalSecurityDomeTurret";

export const aiMs4: Product = {
  id: "aiMs4",
  productTitle: "AI Multi Sensor 4",
  description: "aiMs4.description",
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-ms-4`],
  productListGroup: physicalSecurityDomeTurret,
  storePathParts: {
    productSlug: "uvc-ai-ms-4",
    category: "cameras-dome-turret",
  },
  image: { src: image, width: 200, height: 140 },
  isNew: true,
  isComingSoon: true,
  comingSoonButtonText: "aiMs4.comingSoonButtonText",
  propertyValues: [
    {
      propertyId: "dimensions",
      value: { type: "string", value: 'Ø255 x 105 mm\n(Ø10.04 x 4.13")' },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/2.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: { type: "translation", value: "aiMs4.fieldOfView" },
    },
    {
      propertyId: "nightVision",
      value: { type: "translation", value: "aiMs4.nightVision" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK10" },
    },
    {
      propertyId: "deployment",
      value: { type: "string", value: "PoE++" },
    },
  ],
};
